<template>
  <hm-content title="">
    <div class="">
      <el-radio-group
        v-model="searchCondition.auditState"
        size="small"
        @change="switchTab"
      >
        <el-radio-button label="wait"
          >待审核({{ auditInfoList.waitNum }})</el-radio-button
        >
        <el-radio-button label="agree"
          >已同意({{ auditInfoList.agreeNum }})</el-radio-button
        >
        <el-radio-button label="refuse"
          >已驳回({{ auditInfoList.refuseNum }})</el-radio-button
        >
      </el-radio-group>
      <div class="table-panel flex flex-end mt20">
        <div>
          <el-input
            clearable
            v-model.trim="searchCondition.keyword"
            placeholder="请输入编号/名称"
            size="small"
            class="ipt mr10"
          ></el-input>
          <el-select
            size="small"
            clearable
            class="mr10"
            placeholder="请选择奖励类型"
            v-model="searchCondition.rewardType"
            filterable
          >
            <el-option label="基础奖励" value="basic"></el-option>
            <el-option label="活动奖励" value="activity"></el-option>
          </el-select>
          <el-select
            size="small"
            clearable
            class="mr10"
            placeholder="请选择奖励项目"
            v-model="searchCondition.ruleMode"
            filterable
          >
            <el-option label="积分" value="integral"></el-option>
            <el-option label="成长值" value="growth"></el-option>
          </el-select>
          <!-- <el-date-picker
            v-model="searchCondition.applyDate"
            type="daterange"
            align="right"
            start-placeholder="申请开始日期"
            end-placeholder="申请结束日期"
            value-format="yyyy-MM-dd"
            size="small"
            class="mr10"
          ></el-date-picker> -->
          <el-button type="primary" size="small" @click="search"
            >查询</el-button
          >
        </div>
      </div>
      <div class="table">
        <el-table
          stripe
          border
          ref="table"
          :data="auditInfoList.auditInfoModelIPage.records"
          style="width: 100%"
          size="small"
        >
          <el-table-column
            type="index"
            label="序号"
            :index="index => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="ruleMode"
            label="奖励项目"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.ruleMode === 'integral'">
                积分
              </div>
              <div v-if="scope.row.ruleMode === 'growth'">
                成长值
              </div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="rewardType"
            label="奖励类型"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.rewardType === 'basic'">
                基础奖励
              </div>
              <div v-if="scope.row.rewardType === 'activity'">
                活动奖励
              </div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="ruleSn"
            label="编号"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="ruleName"
            label="名称"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="idcard"
            label="时段"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="ruleRemark"
            label="备注"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="ruleLabel"
            label="标签"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="auditTime"
            label="审核时间"
            v-if="
              searchCondition.auditState === 'agree' ||
                searchCondition.auditState === 'refuse'
            "
          >
            <template slot-scope="scope">
              {{ scope.row.auditTime }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="auditState"
            label="审核状态"
          >
            <template slot-scope="scope">
              <div class="blue" v-if="scope.row.auditState === 'wait'">
                待审核
              </div>
              <div class="success" v-if="scope.row.auditState === 'agree'">
                同意
              </div>
              <div class="danger" v-if="scope.row.auditState === 'refuse'">
                驳回
              </div>
            </template>
          </el-table-column>

          <el-table-column
            v-if="searchCondition.auditState === 'wait'"
            header-align="center"
            align="center"
            prop="orderSn"
            label="操作"
            width="200"
          >
            <template slot-scope="scope">
              <div class="flex flex-center">
                <el-button size="small" type="text" @click="details(scope.row)"
                  >详情</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="hm-pagination">
          <el-pagination
            background
            :total="auditInfoList.auditInfoModelIPage.total"
            @current-change="paging"
            @size-change="handleSizeChange"
            layout="total,sizes,  prev, pager, next, jumper"
            :current-page="currentPage"
          ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      title="规则编辑"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="60%"
    >
      <div class="mb20">
        <el-form ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="规则名称：">
            {{ ruleForm.ruleName }}
            <!-- <el-input
              size="small"
              disabled
              v-model="ruleForm.ruleName"
            ></el-input> -->
          </el-form-item>
          <el-form-item label="规则编号：">
            {{ ruleForm.ruleSn }}
            <!-- <el-input
              size="small"
              disabled
              v-model="ruleForm.ruleSn"
            ></el-input> -->
          </el-form-item>
          <el-form-item label="规则标签：" prop="tag">
            <el-tag
              :key="i"
              v-for="(v, i) in ruleForm.tag"
              :disable-transitions="false"
              >{{ v }}</el-tag
            >
          </el-form-item>
          <el-form-item label="详细规则：" prop="integralAmount">
            <div class="flex way">
              <div class="way-item flex">
                <span>每获得红包</span>
                <div class="item">
                  {{ ruleForm.redpacketMoney }}
                  <!-- <el-input
                    disabled
                    size="small"
                    v-model="ruleForm.redpacketMoney"
                    type="number"
                  ></el-input
                  > -->
                  元，
                </div>
              </div>
              <div class="way-item flex">
                <span>奖励</span>
                <div class="item">
                  {{ ruleForm.integral }}
                  <!-- <el-input
                    disabled
                    v-model="ruleForm.integral"
                    type="number"
                    size="small"
                  ></el-input
                  > -->
                  积分
                </div>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="p20">
        <div class="title">操作日志</div>
      </div>
      <el-table
        stripe
        border
        :data="logs"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
          :index="
            index => index + (currentPageDetails - 1) * pageSizeDetails + 1
          "
        ></el-table-column>
        <!-- <el-table-column
          header-align="center"
          align="center"
          prop="beforeDataValue"
          label="操作前"
        ></el-table-column> -->
        <el-table-column
          header-align="center"
          align="center"
          prop="afterDataValue"
          label="操作结果"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="operateName"
          label="操作人"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="createTime"
          label="操作时间"
        >
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="detailsTotal"
          @current-change="pagingDetails"
          @size-change="handleSizeChangeDetails"
          layout="total,sizes,  prev, pager, next, jumper"
          :current-page="currentPageDetails"
        ></el-pagination>
      </div>
      <div class="flex flex-center mt20">
        <el-button type="success" size="small" @click="pass">同意</el-button>
        <el-button type="primary" size="small" @click="reject">驳回</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="驳回备注"
      :visible="detailsVisible"
      @close="detailsVisible = false"
      custom-class="sales-volumn-dialog"
    >
      <el-form
        label-width="80px"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
      >
        <el-form-item label="驳回原因" prop="refuseReason">
          <el-input
            maxlength="100"
            placeholder="请输入驳回原因"
            size="small"
            style="width: auto"
            :autosize="{ minRows: 4 }"
            type="textarea"
            v-model="ruleForm.refuseReason"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="submitReject('ruleForm')" size="small" type="primary"
          >确认</el-button
        >
        <el-button @click="detailsVisible = false" size="small">关闭</el-button>
      </span>
    </el-dialog>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  components: {},
  data() {
    return {
      searchCondition: {
        auditState: "wait"
      },
      ruleForm: {
        refuseReason: ""
      },
      rules: {
        refuseReason: {
          required: true,
          message: "请输入驳回原因",
          trigger: "change"
        }
      },
      row: {},
      dialogVisible: false,
      detailsVisible: false,
      currentPage: 1,
      pageSize: 10,
      currentPageDetails: 1,
      pageSizeDetails: 10,
      detailsTotal: 0,
      logs: []
    };
  },
  computed: mapGetters(["auditInfoList"]),
  watch: {},
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    queryList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.startTime =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[0]
          : "";
      searchCondition.endTime =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[1]
          : "";
      Object.assign(params, searchCondition);
      this.$store.dispatch("queryAuditInfoList", params);
    },
    async queryLogList() {
      let params = {
        pageNo: this.currentPageDetails,
        pageSize: this.pageSizeDetails,
        ruleId: this.row.ruleId
      };

      const { result } = await this.$store.dispatch("queryFindLogList", params);
      const { records, total } = result;

      this.logs = records;
      this.detailsTotal = total;
    },
    switchTab() {
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    pagingDetails(page) {
      this.currentPageDetails = page;
      this.queryLogList();
    },
    handleSizeChangeDetails(size) {
      this.currentPageDetails = 1;
      this.pageSizeDetails = size;
      this.queryLogList();
    },
    details(row) {
      this.row = row;
      this.dialogVisible = true;
      this.queryDetails();
      this.queryLogList();
    },
    async queryDetails() {
      const { result } = await this.$store.dispatch("detailsIntegralRul", {
        ruleId: this.row.ruleId
      });

      this.ruleForm.ruleName = result.ruleName;
      this.ruleForm.ruleSn = result.ruleSn;
      this.ruleForm.ruleId = result.ruleId;
      this.ruleForm.tag = [];
      this.ruleForm.tag.push(result.ruleLabel);
      if (result.ruleSn === "95811141149470") {
        const { amount, award } = JSON.parse(result.ruleDetail);
        this.ruleForm.redpacketMoney = amount;
        this.ruleForm.integral = award;
      } else if (result.ruleSn === "95824031940683") {
        const { amount, award } = JSON.parse(result.ruleDetail);
        this.ruleForm.redpacketMoney = amount;
        this.ruleForm.integral = award;
      }
    },
    async operation(state) {
      this.row.auditState = state;
      Object.assign(this.row, this.ruleForm);
      const { code } = await this.$store.dispatch(
        "operationIntegralRulState",
        this.row
      );
      if (code === "0") {
        this.$message({
          message: "操作成功！",
          type: "success"
        });
        this.queryList();
        this.dialogVisible = false;
        this.detailsVisible = false;
      }
    },
    pass() {
      this.operation("agree");
    },
    reject() {
      this.detailsVisible = true;
    },
    async submitReject(formName) {
      const valid = await this.$refs[formName].validate();
      if (valid) {
        this.operation("refuse");
      } else {
        return false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.rule-item {
  width: 324px;
  height: 207px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 36px 0px rgba(219, 219, 219, 0.5);
  border-radius: 5px;
  padding: 30px 21px;
  box-sizing: border-box;
  margin: 0 42px 42px 0;
  .rule-row {
    margin-bottom: 20px;
  }

  .label {
    width: 70px;
    text-align: right;
  }

  .tags {
    .tag {
      background: rgba(238, 238, 238, 1);
      border-radius: 2px;
      text-align: center;
      line-height: 26px;
      margin-right: 5px;
      font-size: 12px;
      padding: 0 5px;
    }
  }
}

.title {
  &::before {
    content: "";
    display: inline-block;
    width: 4px;
    height: 14px;
    background: #e50065;
    box-shadow: 0px 0px 16px 0px rgba(216, 216, 216, 0.79);
    margin-right: 5px;
    border-radius: 5px 0 5px 0;
  }
}
</style>
